import axios from 'axios';

const API = process.env.REACT_APP_API_URL ?? 'http://localhost:5125';

export const adminLogin = (password) =>
  axios.post(`${API}/admin/login`, { password });

export const getContacts = () => axios.get(`${API}/contacts`);
export const deleteContact = (id) => axios.delete(`${API}/contacts/${id}`);
export const updateContact = (data) => axios.put(`${API}/contacts`, data);

export const getPhotos = () => axios.get(`${API}/photos`);
export const updatePhotoTitle = (id, title) => axios.patch(`${API}/photos/${id}/title`, { title });
export const getPhotosByCategory = (cat) => axios.get(`${API}/photos/category/${encodeURIComponent(cat)}`);
export const uploadPhoto = (formData) =>
  axios.post(`${API}/photos`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deletePhoto = (id) => axios.delete(`${API}/photos/${id}`);
